import DigiDiaryReducer from './reducers/digiDiaryReducer';
import DigiDiaryViewReducer from './reducers/digiDiaryViewReducer';
import nonMfaProfileReducer from './reducers/nonMfaProfileReducer';
import MFAReducer from './reducers/reducer';
import ResaleReducer from './resale/resale.reducer';

import {combineReducers} from 'redux';

export const AppCombineReducers = combineReducers({
  mfaStates: MFAReducer,
  digiDiaryViewStates: DigiDiaryViewReducer,
  digiDiaryStates: DigiDiaryReducer,
  resale: ResaleReducer,
  profile: nonMfaProfileReducer,
});
